// Rubyz Cosmetics theme — base JS (foundation stub, extended per section).
document.addEventListener('DOMContentLoaded', function () {
  document.documentElement.classList.add('js-enabled');
  initHeroSlideshow();
  initDealsCarousels();
  initRowCarousels();
  initBackToTop();
  initDeliveryCity();
  initProductAddToCart();
});

function initDeliveryCity() {
  var root = document.querySelector('[data-delivery-city]');
  if (!root) return;

  var select = root.querySelector('[data-delivery-city-select]');
  var otherWrap = root.querySelector('[data-delivery-city-other]');
  var otherInput = root.querySelector('[data-delivery-city-other-input]');
  var attributeInput = root.querySelector('[data-delivery-city-attribute]');
  var checkoutInput = root.querySelector('[data-delivery-city-checkout]');
  var form = root.closest('form');
  var checkoutButton = form ? form.querySelector('[data-checkout-button]') : null;
  if (!select || !otherWrap || !otherInput || !attributeInput || !checkoutInput || !checkoutButton) return;

  function syncCity() {
    var isOther = select.value === '__other__';
    otherWrap.hidden = !isOther;
    otherInput.disabled = !isOther;
    otherInput.required = isOther;
    var city = isOther ? otherInput.value.trim() : select.value;
    attributeInput.value = city;
    checkoutInput.value = city;
  }

  select.addEventListener('change', syncCity);
  otherInput.addEventListener('input', syncCity);
  checkoutButton.addEventListener('click', function (event) {
    syncCity();
    if (!select.reportValidity() || (otherInput.required && !otherInput.reportValidity())) {
      event.preventDefault();
      return;
    }

    var city = checkoutInput.value;
    var permalink = checkoutButton.getAttribute('data-cart-permalink');
    if (!city || !permalink) return;

    event.preventDefault();
    var query = new URLSearchParams();
    query.set('checkout[shipping_address][city]', city);
    query.set('checkout[shipping_address][country]', 'Jordan');
    query.set('attributes[Delivery city]', city);
    window.location.assign(permalink + '?' + query.toString());
  });
  syncCity();
}

function initDealsCarousels() {
  var tracks = document.querySelectorAll('[data-deals-track]');
  tracks.forEach(function (track) {
    var viewport = track.closest('.deals-carousel__viewport');
    if (!viewport) return;
    var prevBtn = viewport.querySelector('[data-deals-prev]');
    var nextBtn = viewport.querySelector('[data-deals-next]');
    var isRtl = document.documentElement.getAttribute('dir') === 'rtl';
    var dir = isRtl ? -1 : 1;

    function scrollByCards() {
      var card = track.querySelector('.product-card');
      var amount = card ? (card.getBoundingClientRect().width + 20) * 2 : 400;
      return amount;
    }
    if (nextBtn) nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: dir * scrollByCards(), behavior: 'smooth' });
    });
    if (prevBtn) prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -dir * scrollByCards(), behavior: 'smooth' });
    });
  });
}

/* Homepage Popular Brands / Best Seller / Perfume / New Products rows — same
   arrow-scroll pattern as the deals carousel above, generalized for any
   [data-row-track] (see .home-row-carousel markup in sections/main-index.liquid). */
function initRowCarousels() {
  var tracks = document.querySelectorAll('[data-row-track]');
  tracks.forEach(function (track) {
    var wrap = track.closest('.home-row-carousel');
    if (!wrap) return;
    var prevBtn = wrap.querySelector('[data-row-prev]');
    var nextBtn = wrap.querySelector('[data-row-next]');
    var isRtl = document.documentElement.getAttribute('dir') === 'rtl';
    var dir = isRtl ? -1 : 1;

    function scrollByCards() {
      var card = track.querySelector('.product-card, .brand-card');
      var gap = 20;
      var amount = card ? (card.getBoundingClientRect().width + gap) * 2 : 400;
      return amount;
    }
    if (nextBtn) nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: dir * scrollByCards(), behavior: 'smooth' });
    });
    if (prevBtn) prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -dir * scrollByCards(), behavior: 'smooth' });
    });
  });
}

/* Back-to-top button — hidden until the user scrolls past one viewport height,
   matching Magento's behavior (bottom-right, persists across every page). */
function initBackToTop() {
  var btn = document.getElementById('BackToTop');
  if (!btn) return;
  var threshold = 400;

  function toggle() {
    if (window.scrollY > threshold) btn.classList.add('is-visible');
    else btn.classList.remove('is-visible');
  }
  window.addEventListener('scroll', toggle, { passive: true });
  btn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
  toggle();
}

function initHeroSlideshow() {
  var root = document.getElementById('HeroSlideshow');
  if (!root) return;
  var slides = root.querySelectorAll('.hero-slideshow__slide');
  var dots = root.querySelectorAll('.hero-slideshow__dot');
  if (slides.length < 2) return;

  var current = 0;
  var delay = parseInt(root.getAttribute('data-autoplay'), 10) || 5000;
  var timer = null;

  function show(index) {
    index = (index + slides.length) % slides.length;
    slides[current].classList.remove('is-active');
    if (dots[current]) dots[current].classList.remove('is-active');
    current = index;
    slides[current].classList.add('is-active');
    if (dots[current]) dots[current].classList.add('is-active');
  }

  function next() { show(current + 1); }
  function prev() { show(current - 1); }

  function start() {
    stop();
    timer = setInterval(next, delay);
  }
  function stop() {
    if (timer) clearInterval(timer);
  }

  var nextBtn = document.getElementById('HeroNext');
  var prevBtn = document.getElementById('HeroPrev');
  if (nextBtn) nextBtn.addEventListener('click', function () { next(); start(); });
  if (prevBtn) prevBtn.addEventListener('click', function () { prev(); start(); });
  dots.forEach(function (dot, i) {
    dot.addEventListener('click', function () { show(i); start(); });
  });

  root.addEventListener('mouseenter', stop);
  root.addEventListener('mouseleave', start);

  start();
}

/* Quick add: add products without leaving the current page. */
function initQuickAdd() {
  var forms = document.querySelectorAll('.product-card__quick-add form');
  forms.forEach(function (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var button = form.querySelector('button[type="submit"]');
      if (!button || button.disabled) return;
      var originalText = button.textContent;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart add failed');
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
        })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          var count = document.querySelector('.site-header__cart-count');
          if (!count) {
            var cartLink = document.querySelector('.site-header__icon-link[href*="cart"]');
            if (cartLink) {
              count = document.createElement('span');
              count.className = 'site-header__cart-count';
              cartLink.appendChild(count);
            }
          }
          if (count) count.textContent = cart.item_count;
          var message = form.parentElement.querySelector('.quick-add-message');
          if (!message) {
            message = document.createElement('span');
            message.className = 'quick-add-message';
            form.parentElement.appendChild(message);
          }
          message.textContent = document.documentElement.getAttribute('dir') === 'rtl'
            ? 'تمت إضافة المنتج إلى السلة'
            : 'Item added to cart';
          message.setAttribute('role', 'status');
          button.textContent = originalText;
          button.removeAttribute('aria-busy');
          button.disabled = false;
          window.setTimeout(function () {
            if (message) message.remove();
          }, 3000);
        })
        .catch(function () {
          button.textContent = originalText;
          button.removeAttribute('aria-busy');
          button.disabled = false;
        });
    });
  });
}

/* Product-page add to cart: stay on the page and confirm the selected variant. */
function initProductAddToCart() {
  var form = document.getElementById('ProductForm');
  if (!form) return;
  form.addEventListener('submit', function (event) {
    if (!event.submitter || event.submitter.id !== 'AddToCartButton') return;
    event.preventDefault();

    var button = event.submitter;
    if (button.disabled) return;
    var originalText = button.textContent;
    var message = document.getElementById('ProductAddMessage');

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart add failed');
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var count = document.querySelector('.site-header__cart-count');
        if (!count) {
          var cartLink = document.querySelector('.site-header__icon-link[href*="cart"]');
          if (cartLink) {
            count = document.createElement('span');
            count.className = 'site-header__cart-count';
            cartLink.appendChild(count);
          }
        }
        if (count) count.textContent = cart.item_count;

        if (message) {
          message.textContent = document.documentElement.getAttribute('dir') === 'rtl'
            ? 'تمت إضافة المنتج إلى السلة'
            : 'Item added to cart';
          message.hidden = false;
        }
        button.textContent = originalText;
        button.removeAttribute('aria-busy');
        button.disabled = false;
        window.setTimeout(function () {
          if (message) {
            message.hidden = true;
            message.textContent = '';
          }
        }, 3000);
      })
      .catch(function () {
        button.textContent = originalText;
        button.removeAttribute('aria-busy');
        button.disabled = false;
      });
  });
}

document.addEventListener('DOMContentLoaded', initQuickAdd);
